export const ADMIN = {
  // Login
  loginPage: "admin-login-page",
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  loginError: "admin-login-error",

  // Dashboard
  dashboard: "admin-dashboard",
  dashboardHeading: "admin-dashboard-heading",
  dashboardLogout: "admin-logout-btn",
  dashboardExport: "admin-export-csv",
  dashboardRefresh: "admin-refresh",
  dashboardCount: "admin-count",
  dashboardTable: "admin-table",
  dashboardRow: (id) => `admin-row-${id}`,
  dashboardDeleteBtn: (id) => `admin-delete-${id}`,
  dashboardEmpty: "admin-empty",
};
